export default __webpack_public_path__ + "static/media/yelp.f26b27e2.svg";